export const trackingLinkCategories = ['g2'] as const;
export type TrackingLinkCategory = (typeof trackingLinkCategories)[number];
